module.exports = __webpack_public_path__ + "img/20191126162206360截图20191126160949445.ae538027.jpg";